export default __webpack_public_path__ + "static/media/demo.3f8c0ac0.svg";